import { Context, useContext } from "react";

export const useAccurateContext = <T,>(ctx: Context<T | null>): T => {
  const context = useContext(ctx);

  if (!context) {
    throw new Error("Пустое значение контекста");
  }

  return context;
};
